module.exports = __webpack_public_path__ + "static/media/call_queue.1b610752.svg";